import { FC } from "react";
import { Controller, Navigation, Pagination, Thumbs } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import InstructorCard from "./instructor-card";

const InstructorListSkeleton: FC = () => {
  return (
    <div className="pt-8 flex flex-col md:border rounded-zinc-100 rounded-lg max-w-[1232px] w-full px-5 relative">
      <div className="h-6 w-[33%] bg-gray-50 animate-pulse mb-4"></div>

      <div className="flex flex-wrap">
        <div className="min-w-0 break-words bg-white w-full overflow-x-hidden mb-3 courseCard ml-1 mt-8">
          <Swiper
            navigation={{
              nextEl: `.swiper-button-next`,
              prevEl: `.swiper-button-prev `,
            }}
            className="swiper"
            slidesPerView="auto"
            spaceBetween={15}
            modules={[Controller, Navigation, Pagination, Thumbs]}
          >
            {Array.from({ length: 6 }, (v, i) => i)?.map((value) => {
              return (
                <SwiperSlide key={`${value}`} className=" relative">
                  <InstructorCard />
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div
            className={`hover:text-primaryHover text-primary swiper-button-next left-0 md:left-[-2vw] right-[unset] swiper-button-next`}
          ></div>
          <div
            className={`hover:text-primaryHover text-primary swiper-button-prev right-0 md:right-[-2vw] left-[unset] swiper-button-prev`}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default InstructorListSkeleton;
